export const paragraphs = (text = '') =>
  text
    .replace(/\r\n?/g, '\n')
    .split(/\n/)
    .map((s) => s.trim())
    .map((t, index) => {
      if (t.length === 0) return <br key={index} />;
      return <p key={index}>{t}</p>;
    });
